import IAppLogger from '@app/lib/IAppLogger';
import { audioDevicesState } from '@modules/SoftPhoneModule/audioDevicesState';
import { MicMonitorStartedPayload } from '@modules/SoftPhoneModule/types';
import { webPhoneEventNames } from '@modules/SoftPhoneModule/constants/events';

/**
 * Handles `webphone:mic-monitor-started` from the webphone MFE when microphone
 * monitoring for the mic test has started successfully.
 */
const handleMicMonitorStarted = (
  payload: MicMonitorStartedPayload,
  logger: IAppLogger,
): void => {
  logger.debug(webPhoneEventNames.micMonitorStarted, {
    loopback: payload.loopback,
  });
  audioDevicesState.isTestingMicrophone = true;
};

export default handleMicMonitorStarted;
